import apiService from './apiService';

class FilesService {
  // File Management
  async getFiles(folderId = null) {
    try {
      const result = await apiService.getFiles(folderId);
      return result;
    } catch (error) {
      console.error('Error fetching files:', error);
      throw error;
    }
  }

  async getFile(fileId) {
    try {
      const result = await apiService.getFile(fileId);
      return result;
    } catch (error) {
      console.error('Error fetching file:', error);
      throw error;
    }
  }

  async uploadFiles(formData) {
    try {
      const result = await apiService.uploadFiles(formData);
      return result;
    } catch (error) {
      console.error('Error uploading files:', error);
      throw error;
    }
  }

  async updateFileStatus(fileId, status) {
    try {
      const result = await apiService.updateFileStatus(fileId, status);
      return result;
    } catch (error) {
      console.error('Error updating file status:', error);
      throw error;
    }
  }

  async deleteFile(fileId) {
    try {
      const result = await apiService.deleteFile(fileId);
      return result;
    } catch (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  }

  // Filter Management
  async getFilters() {
    try {
      const result = await apiService.getFilters();
      return result;
    } catch (error) {
      console.error('Error fetching filters:', error);
      throw error;
    }
  }

  async getFilter(filterId) {
    try {
      const result = await apiService.getFilter(filterId);
      return result;
    } catch (error) {
      console.error('Error fetching filter:', error);
      throw error;
    }
  }

  async createFilter(filterConfig) {
    try {
      const result = await apiService.createFilter(filterConfig);
      return result;
    } catch (error) {
      console.error('Error creating filter:', error);
      throw error;
    }
  }

  async updateFilter(filterId, filterConfig) {
    try {
      const result = await apiService.updateFilter(filterId, filterConfig);
      return result;
    } catch (error) {
      console.error('Error updating filter:', error);
      throw error;
    }
  }

  async deleteFilter(filterId) {
    try {
      const result = await apiService.deleteFilter(filterId);
      return result;
    } catch (error) {
      console.error('Error deleting filter:', error);
      throw error;
    }
  }

  // Stats
  async getStats() {
    try {
      const result = await apiService.getStats();
      return result;
    } catch (error) {
      console.error('Error fetching stats:', error);
      throw error;
    }
  }

  // Auto-detect tags for file naming
  autoDetectTags(fileName) {
    const name = fileName.toLowerCase();
    
    // Define tag patterns
    const tagPatterns = {
      'SOP': ['sop', 'standard', 'procedure', 'policy'],
      'POLICY': ['policy', 'policies', 'guideline', 'guidelines'],
      'BP': ['best', 'practice', 'bp', 'template'],
      'TEMPLATE': ['template', 'templates', 'form', 'forms'],
      'ADV': ['advice', 'advisory', 'recommendation', 'guide'],
      'TRAINING': ['training', 'tutorial', 'course', 'learning'],
      'CALL_LOG': ['call', 'log', 'transcript', 'recording'],
      'ORG': ['org', 'organization', 'company', 'corporate'],
      'TRADE_SECRET': ['secret', 'confidential', 'proprietary', 'internal'],
      'DELIVERY': ['delivery', 'shipping', 'logistics', 'fulfillment'],
      'PERSONA': ['persona', 'profile', 'customer', 'user'],
      'TP': ['tp', 'third', 'party', 'external'],
      'TLD': ['tld', 'top', 'level', 'domain'],
      'NICHE': ['niche', 'specialized', 'expert', 'technical'],
      'DNS': ['dns', 'domain', 'name', 'system']
    };

    // Find matching patterns
    const matchedTags = [];
    for (const [tag, patterns] of Object.entries(tagPatterns)) {
      if (patterns.some(pattern => name.includes(pattern))) {
        matchedTags.push(tag);
      }
    }

    // Return primary and secondary tags
    return {
      primaryTag: matchedTags[0] || null,
      secondaryTags: matchedTags.slice(1)
    };
  }
}

const filesService = new FilesService();
export default filesService;
